import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class DateRangePickerService {
  public applyDisabled = new BehaviorSubject(false);
  public customPresets: string[] = [];
}

import { NgFor, NgIf, CommonModule } from '@angular/common';
import { HttpParams, HttpParamsOptions } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { Filters } from '../../../mock-data/mock-filters';
import { Filter } from '../../../interfaces/filter';

import {
  MatDatepickerModule,
  MatDateRangeInput,
  MatDateRangePicker,
  MatDateSelectionModel,
  MatStartDate,
} from '@angular/material/datepicker';
import {
  MatNativeDateModule,
  MatOptionModule,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { PTicketFilterPresetComponent } from '../p-ticket-filter-preset/p-ticket-filter-preset.component';
import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
import { masterCountryCode } from '../../../interfaces/masterData';
import { MasterDataService } from '../../../services/master-data.service';
import {
  MatAutocomplete,
  MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { OrganizationService } from '../../../services/organization.service';
import { globalUser } from '../../../helpers/globalFields';
@Component({
  selector: 'app-p-ticket-filter',
  standalone: true,
  providers: [DateRangePickerService, provideNativeDateAdapter()],
  imports: [
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    NgFor,
    MatChipsModule,
    MatMenuModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatIconModule,
    MatNativeDateModule,
    CommonModule,
    MatAutocompleteModule,
    MatOptionModule,
  ],
  templateUrl: './p-ticket-filter.component.html',
  styleUrl: './p-ticket-filter.component.scss',
})
export class PTicketFilterComponent {
  @Output() httpFilterList = new EventEmitter<HttpParams>();
  @Input() activeFilters: { key: Filter; value: string }[] = [];
  @Input() customPresets: string[] = [];
  @Input() persistInLocalStorage: boolean = false;
  @ViewChild('dateRangeInput', { static: false })
  dateRangeInput!: MatDateRangeInput<Date>;
  @ViewChild(PTicketFilterPresetComponent)
  presetCmp!: PTicketFilterPresetComponent<Date>;

  filterOptions = Filters.filter((f) => f.displayed === true);
  httpParams: HttpParams = new HttpParams();
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  PTicketFilterPresetComponent = PTicketFilterPresetComponent;
  @ViewChild('filterType') filterType!: MatMenu;
  constructor(
    public pickerService: DateRangePickerService,
    private masterDataService: MasterDataService,
    private organizationService: OrganizationService,
  ) {}

  ngOnInit() {
    if (this.persistInLocalStorage) {
      const saved = localStorage.getItem('pTicketFilters');
      if (saved) {
        const { filters, dateRange } = JSON.parse(saved);

        this.activeFilters = filters
          .map((f: { db_key: string; value: any }) => {
            const option = this.filterOptions.find(
              (o) => o.db_key === f.db_key,
            );
            return option ? { key: option, value: f.value } : null;
          })
          .filter((f: any) => f !== null) as { key: Filter; value: string }[];

        if (dateRange?.start)
          this.range.patchValue({ start: new Date(dateRange.start) });
        if (dateRange?.end)
          this.range.patchValue({ end: new Date(dateRange.end) });
      }
    } else {
      // Convert HttpParams (activeFilters) to range and rebuild HttpParams
      const startStr = this.activeFilters.find(
        (f) => f.key.db_key === 'updatedAt[$gte]',
      )?.value;
      const endStr = this.activeFilters.find(
        (f) => f.key.db_key === 'updatedAt[$lte]',
      )?.value;

      if (startStr && endStr) {
        this.range.patchValue({
          start: new Date(startStr),
          end: new Date(endStr),
        });
      }
    }
    if (!this.range.value.start || !this.range.value.end) {
      const defaultStart = new Date();
      defaultStart.setMonth(defaultStart.getMonth() - 1); // 1 month ago
      const defaultEnd = new Date();

      this.range.patchValue({ start: defaultStart, end: defaultEnd });

      // Also add to activeFilters
      const updatedAtGte = this.filterOptions.find(
        (f) => f.db_key === 'updatedAt[$gte]',
      );
      const updatedAtLte = this.filterOptions.find(
        (f) => f.db_key === 'updatedAt[$lte]',
      );
      if (updatedAtGte && updatedAtLte) {
        this.activeFilters.push(
          { key: updatedAtGte, value: defaultStart.toISOString() },
          { key: updatedAtLte, value: defaultEnd.toISOString() },
        );
      }
    }
    // Set default date range if nothing is set
    // const oneMonthAgo = new Date();
    // oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    // if (!this.range.value.start) this.range.patchValue({ start: oneMonthAgo });
    // if (!this.range.value.end) this.range.patchValue({ end: new Date() });

    this.pickerService.customPresets = this.customPresets;
    this.masterDataService
      .getMasterCountrycodeMockList()
      .subscribe((countryCodes) => {
        this.countryCodes = countryCodes;
        this.filteredcountryCodes = this.countryCodes;
      });

    Filters.forEach((filter) => {
      if (filter.db_key === 'pct_organization') {
        filter.options = globalUser.getUser().organizations;
      }
    });

    this.rebuildHttpParams();
  }

  ngAfterViewInit() {
    PTicketFilterPresetComponent.presetSelected.subscribe((preset) => {
      this.range.setValue({ start: preset.start, end: preset.end });
      this.rebuildHttpParams();
    });
  }
  isDateFilter(filter: { key: Filter; value: string }): boolean {
    return (
      filter.key.db_key === 'updatedAt[$gte]' ||
      filter.key.db_key === 'updatedAt[$lte]'
    );
  }
  addFilter(filter: Filter, value: string) {
    const exists = this.activeFilters.find(
      (f) => f.key.db_key === filter.db_key && f.value === value,
    );
    if (!exists) this.activeFilters.push({ key: filter, value });
    this.rebuildHttpParams();
    this.filteredcountryCodes = this.countryCodes;
  }

  removeFilter(index: number) {
    this.activeFilters.splice(index, 1);
    this.rebuildHttpParams();
  }

  applySelectedDate(picker: MatDateRangePicker<Date>) {
    picker.close();
    this.rebuildHttpParams();
  }

  rebuildHttpParams() {
    this.httpParams = new HttpParams();
    this.activeFilters = this.activeFilters.filter((filter) => {
      if (filter.key.db_key !== 'pct_organization') {
        return true; // keep all non-org filters
      }
      // only keep org filters where the value is in the user's orgs
      else {
        console.log(filter.value);
        console.log(globalUser.getUser());
        return globalUser
          .getUser()
          .organizations?.some((org) => org === filter.value);
      }
    });
    // Add all filters
    this.activeFilters.forEach((f) => {
      this.httpParams = this.httpParams.append(f.key.db_key, f.value);
    });
    console.log(this.activeFilters);

    // this.organizationService
    //   .getOrganizationListByUser()
    //   .subscribe((response) => {
    //     this.activeFilters = this.activeFilters.filter((filter) => {
    //       if (filter.key.db_key !== 'pct_organization') {
    //         return true; // keep all non-org filters
    //       }
    //       // only keep org filters where the value is in the user's orgs
    //       return globalUser
    //         .getUser()
    //         .organizations?.some((org) => org === filter.value);
    //     });
    //   });

    // Add date range
    const start = this.range.value.start;
    const end = this.range.value.end;
    if (start && end) {
      this.httpParams = this.httpParams
        .delete('updatedAt[$gte]')
        .delete('updatedAt[$lte]')
        .append('updatedAt[$gte]', start.toISOString())
        .append('updatedAt[$lte]', end.toISOString());
    }

    this.httpFilterList.emit(this.httpParams);

    // Only save to localStorage if the flag is true
    if (this.persistInLocalStorage) this.saveToLocalStorage();
  }

  private saveToLocalStorage() {
    const filtersToSave = this.activeFilters.map((f) => ({
      db_key: f.key.db_key,
      value: f.value,
    }));
    const dateRange = {
      start: this.range.value.start?.toISOString() || null,
      end: this.range.value.end?.toISOString() || null,
    };
    localStorage.setItem(
      'pTicketFilters',
      JSON.stringify({ filters: filtersToSave, dateRange }),
    );
  }

  private loadFromLocalStorage() {
    const saved = localStorage.getItem('pTicketFilters');
    if (!saved) return;

    const { filters, dateRange } = JSON.parse(saved);

    this.activeFilters = filters
      .map((f: { db_key: string; value: any }) => {
        const option = this.filterOptions.find((o) => o.db_key === f.db_key);
        return option ? { key: option, value: f.value } : null;
      })
      .filter((f: any) => f !== null) as { key: Filter; value: string }[];

    if (dateRange?.start)
      this.range.patchValue({ start: new Date(dateRange.start) });
    if (dateRange?.end) this.range.patchValue({ end: new Date(dateRange.end) });
  }

  /**
   * filters the countryCodes list by typing
   *
   * @param event on filter input update the displayed list
   */
  /*filterKeywords(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    if (!filterValue) {
      this.filteredcountryCodes = [];
      return;
    }
    else {

      this.filteredcountryCodes = this.countryCodes.filter(countrycode => Object.values(countrycode).some(val =>
        val.toString().toLowerCase().includes(filterValue.toLowerCase())
      ));
    }
  }*/

  /**
   * list of all country codes with their number and shorthand
   */
  countryCodes!: masterCountryCode[];
  /**
   * list of displayed country codes when searching for a specific one
   */
  filteredcountryCodes!: masterCountryCode[];
  filterKeywords(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredcountryCodes = this.countryCodes.filter(
      (countrycode) =>
        countrycode.cod_alpha2.includes(filterValue) ||
        countrycode.cod_countryname.includes(filterValue) ||
        countrycode.cod_countrycode.includes(filterValue),
    );
  }
}
